import React from "react";
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const CustomDisabledCheckedIcon = () => {

  return (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <RadioButtonUncheckedIcon />
      <FiberManualRecordIcon style={{ color: 'var(--corporate-color)', position: 'absolute', transform: 'scale(0.5)' }} />
    </div>
  );
}

export default CustomDisabledCheckedIcon;